import React from 'react';
import { useSelector } from 'react-redux';
import './ProductReview.scss';
import OdThumbsUpGreen from '../../../../static/assets/img/pdp/od-thumbs-up-green.png';
import OdTwoStars from '../../../../static/assets/img/pdp/od-two-stars.png';
import StarIcon from '../../../../static/assets/svg/star-icon.svg';

const ProductReview = ({ productData }) => {
  const dataLocale = useSelector(state => state.locale);
  const {
    REVIEWS,
    FROM,
    VERIFIED_CUSTOMERS,
    POSITIVE_FEEDBACK,
    CUSTOMERS,
    WOULD_RECOMMEND,
    TO_A_FRIEND,
  } = dataLocale;

  return (
    <>
      <div className="main-content-wrapper">
        <div className="od-product-review">
          <div className="od-product-review__title od-font-reg">OWNDAYS {REVIEWS}</div>

          <div className="od-product-review__info">
            <div className="od-product-review-block">
              <div>
                <div className="od-product-review-block__title od-product-review-block__title--stars od-font-reg">
                  <span className="od-font-bold">4.9</span>
                  <div className="od-product-review-block__stars">
                    <img alt="star" height="24px" src={StarIcon} width="24px" />
                    <img alt="star" height="24px" src={StarIcon} width="24px" />
                    <img alt="star" height="24px" src={StarIcon} width="24px" />
                    <img alt="star" height="24px" src={StarIcon} width="24px" />
                    <img alt="star" height="24px" src={StarIcon} width="24px" />
                  </div>
                </div>
                <div className="od-product-review-block__description od-font-reg">
                  {FROM} 10000+ {VERIFIED_CUSTOMERS}
                </div>
              </div>
            </div>

            <div className="od-product-review-block">
              <img alt="positive feedback" src={OdThumbsUpGreen} />
              <div>
                <div className="od-product-review-block__title od-font-reg">
                  <span className="od-font-bold">96%</span> {POSITIVE_FEEDBACK}
                </div>
                <div className="od-product-review-block__description od-font-reg">
                  {FROM} {CUSTOMERS}
                </div>
              </div>
            </div>

            <div className="od-product-review-block">
              <img alt="would recommend" src={OdTwoStars} />
              <div>
                <div className="od-product-review-block__title od-font-reg">
                  <span className="od-font-bold">99%</span> {WOULD_RECOMMEND}
                </div>
                <div className="od-product-review-block__description od-font-reg">
                  OWNDAYS {TO_A_FRIEND}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductReview;
